export default "__VITE_ASSET__SSi5mPFg__"